<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-content class="marginTop20px mb-5">
    <div id="pgMain" :style="pgStyle">
      <v-layout justify-center>
        <v-flex xs12 sm10 md10>
          <v-card flat color="transparent">
            <v-card-title class="headline font-weight-thin bluetext mt-1">
              {{'WELCOME_TEXT' | translate}} {{foreName}} {{lastName}}
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <v-card flat color="transparent" v-if="showMe">
        <DialogOverallSearch ref="overallSearch"></DialogOverallSearch>
        <moduleList></moduleList>
        <ChangelogEValueRate ref="changeLog"></ChangelogEValueRate>
        <v-layout row justify-center>
          <v-flex md10>
            <NewsboxChanges v-if="false"></NewsboxChanges>
          </v-flex>
        </v-layout>
        <v-layout>
        </v-layout>
      </v-card>
    </div>
  </v-content>

</template>

<script>
  import Vue from 'vue'
  import moduleList from './module/ModuleList.vue'
  import NewsboxChanges from './module/changelog/NewsboxChanges'
  import DialogOverallSearch from './module/dialogs/DialogOverallSearch'
  import ChangelogEValueRate from './widgets/ChangelogEValueRate'

  export default {
    name: 'Dashboard.vue',
    components: {ChangelogEValueRate, moduleList, NewsboxChanges, DialogOverallSearch},
    data() {
      return {
        foreName: '',
        lastName: '',
        pgStyle: '',
        isDebug: false,
        showMe: false
      }
    },
    methods: {
      OnOverallSearch: function (searchText) {
        this.$refs.overallSearch.show(searchText)
      },
      OnResize: function () {
        var footerHeight = $('#footerMenu').height()
        var view = Vue.prototype.$api.getViewport()
        var h2 = view.height - footerHeight - Vue.config.data.TABLE_SHRINK_HEIGHT - 116
        this.pgStyle = 'overflow-y: auto; height: ' + h2 + 'px'
      }
    },
    beforeMount() {
      Vue.prototype.$api.checkCredentials(this)

    },
    created() {
      Vue.prototype.$eventHub.$on('OnOverallSearch', this.OnOverallSearch)
      Vue.prototype.$eventHub.$on('OnResize', this.OnResize)
    },
    destroyed() {
      Vue.prototype.$eventHub.$off('OnOverallSearch', this.OnOverallSearch)
      Vue.prototype.$eventHub.$off('OnResize', this.OnResize)
    },
    mounted() {
      this.showMe = false
      this.OnResize()
      Vue.prototype.$api.debug('Module Dashboard')
      var cmp = this
      if (Vue.prototype.$api.getModuleId()) {
        Vue.prototype.storage.resetAnkerbank(Vue.prototype.$api.getModuleId())
        Vue.prototype.storage.resetPeergroup(Vue.prototype.$api.getModuleId())
      }
      this.isDebug = Vue.prototype.$config.IS_DEBUG
      Vue.prototype.$api.setModuleId(null)
      Vue.prototype.$api.resetParamData()
      Vue.prototype.$eventHub.$emit('OnShowLogin', false)
      Vue.prototype.$api.checkCredentials(cmp, function () {
        cmp.foreName = Vue.prototype.$api.getCredentials().data.user.firstName
        cmp.lastName = Vue.prototype.$api.getCredentials().data.user.lastName
        Vue.prototype.$api.getBreadCrumpModule()
        Vue.prototype.$eventHub.$emit('OnGetModuleTitle', '')
        cmp.showMe = true
        Vue.prototype.$api.resetAll()
        cmp.$nextTick(function () {
          cmp.$refs.changeLog.update()
        })
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue